import React, {useEffect, useState} from "react";
import {Col, Form, Modal} from "react-bootstrap";
import {formToDeepObject} from "../../../../util/Helpers";
import {useUpdatePaymentMutation} from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as handlers from "../../../UserManagement/_redux/selected-user/selectedUserHandlers";

const EditPaymentModal = ({showEditPaymentModal, onHide, details, tableRef, refreshPayments}) => {

    const [validated, setValidated] = useState(false);
    const {userId, accountId} = useParams();
    const dispatch = useDispatch();

    const [
        updatePaymentStatus,
        {
            isLoading: isUpdating,
            isSuccess: updateSuccessful,
        }
    ] = useUpdatePaymentMutation()

    /* Close Modal on successful update */
    useEffect(() => {
        if (updateSuccessful) {
            cogoToast.success("Payment Updated Successfully");
            onHide();
            if (tableRef){
                tableRef.current.refresh()
            }
            else if (refreshPayments) {
                refreshPayments();
            }
            else if (userId && accountId){
                dispatch(handlers.fetchUserAccountDetails(userId, accountId)); 
            }
        }
    }, [updateSuccessful, tableRef, onHide, refreshPayments, userId, accountId, dispatch]);



    /* Update Payment */
    const updatePayment = e => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        const {progress, status} = details

        if (form.checkValidity() === true) {
            const formData = new FormData(form);
            updatePaymentStatus({
                ref: details?.ref,
                userId: details.userId,
                ...formToDeepObject(Object.fromEntries(formData.entries())),
                meta: {
                    progress,
                    status,
                }
            })
        }
        setValidated(true);
    }

    return (
        <Modal
            show={showEditPaymentModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
            onExited={_ => setValidated(false)}
        >
            <Form
                noValidate
                validated={validated}
                onSubmit={updatePayment}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Payment
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>
                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                    <Form.Row>
                        <Form.Group as={Col} md="6" controlId="status">
                            <Form.Label>Status</Form.Label>
                            <Form.Control
                                required
                                as="select"
                                className="mr-sm-2"
                                custom
                                name="status"
                                defaultValue={details?.status}
                            >
                                {
                                    details?.type === "DEPOSIT"
                                        ? <>
                                            <option value="PENDING">PENDING</option>
                                            <option value="PENDING_CONFIRMATION">PENDING_CONFIRMATION</option>
                                            <option value="PROCESSING">PROCESSING</option>
                                            <option value="COMPLETED">COMPLETED</option>
                                            <option value="FAILED">FAILED</option>
                                            <option value="REVERSED">REVERSED</option>
                                            <option value="ABANDONED">ABANDONED</option>
                                            <option value="FLAGGED">FLAGGED</option>
                                        </>
                                        : <>
                                            <option value="PENDING_CONFIRMATION">PENDING_CONFIRMATION</option>
                                            <option value="PROCESSING">PROCESSING</option>
                                            <option value="COMPLETED">COMPLETED</option>
                                            <option value="FAILED">FAILED</option>
                                            <option value="FLAGGED">FLAGGED</option>
                                            <option value="PENDING_REVIEW">PENDING REVIEW</option>
                                        </>
                                }
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                                Select the Admin Status
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        disabled={isUpdating}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isUpdating}
                        className="btn btn-primary btn-elevate px-4 ml-4"
                    >
                        Update
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default EditPaymentModal;